export default __webpack_public_path__ + "static/media/runeofresilience.b97ac88c.png";